<template>
  <div>
    <div class="text-sm mt-4">
      By submitting this order you confirm that you agree <br />to our
      <a href="#terms" class="text-dark underline" @click.prevent="open = !open">Terms & Conditions</a>
    </div>

    <transition name="fade">
      <div
        v-if="open"
        class="mt-2 p-8 bg-light rounded-xl text-content"
      >
        <h4 class="uppercase text-mdx mb-3 font-medium">General Terms & Conditions</h4>
        <ul class="list-disc text-base mb-5 pl-4 space-y-1">
          <li>Tickets purchased are valid for the day of purchase only.</li>
          <li>Visitors are required to report to the ticket counter upon arrival.</li>
          <li>Visitors participate in the tour activity at their own risk.</li>
        </ul>

        <h4 class="uppercase text-mdx mb-3 font-medium">Refunds & Cancellations</h4>
        <ul class="text-base list-disc pl-4 space-y-1">
          <li>A full refund will be provided for cancellations received by close of business (5.00pm WST) on the day prior to the tour.</li>
          <li>In the event of ‘no shows’, or cancellations later than close of business (5.00pm WST) on the day prior to the booking, we may charge the full cost of the booked tour(s).</li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import ConfigMixin from "../mixins/config";
export default {
  mixins: [ConfigMixin],
  data() {
    return {
      open: false,
    }
  },
  computed: {
    terms() {
      return this.options.termsText
    },
  },
}
</script>
